export const CATEGORIES = [
  {
    id: 863,
    url: 'https://www.catawiki.com/en/c/863-archaeology-natural-history',
    name: 'Archaeology & Natural History',
    formatted_name: 'Archaeology & Natural History',
    auction_count: 50,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/863-bd12df0604bca0a6c2b40157d4151eafb53c6499-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/863-bd12df0604bca0a6c2b40157d4151eafb53c6499-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/863-bd12df0604bca0a6c2b40157d4151eafb53c6499-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/863-bd12df0604bca0a6c2b40157d4151eafb53c6499-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/863-bd12df0604bca0a6c2b40157d4151eafb53c6499-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/863-bd12df0604bca0a6c2b40157d4151eafb53c6499-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/863-bd12df0604bca0a6c2b40157d4151eafb53c6499-thumb3.png',
    },
    color: '#c7a881',
    level: 0,
  },
  {
    id: 85,
    url: 'https://www.catawiki.com/en/c/85-art',
    name: 'Art',
    formatted_name: 'Art',
    auction_count: 116,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/85-7b6733020674820d72574dad12be5da35373c3da-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/85-7b6733020674820d72574dad12be5da35373c3da-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/85-7b6733020674820d72574dad12be5da35373c3da-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/85-7b6733020674820d72574dad12be5da35373c3da-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/85-7b6733020674820d72574dad12be5da35373c3da-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/85-7b6733020674820d72574dad12be5da35373c3da-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/85-7b6733020674820d72574dad12be5da35373c3da-thumb3.png',
    },
    color: '#a3cc86',
    level: 0,
  },
  {
    id: 925,
    url: 'https://www.catawiki.com/en/c/925-asian-tribal-art',
    name: 'Asian & Tribal Art',
    formatted_name: 'Asian & Tribal Art',
    auction_count: 37,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/925-3ef497b40eab7ae7961159fd5d4a678eb2166bfc-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/925-3ef497b40eab7ae7961159fd5d4a678eb2166bfc-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/925-3ef497b40eab7ae7961159fd5d4a678eb2166bfc-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/925-3ef497b40eab7ae7961159fd5d4a678eb2166bfc-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/925-3ef497b40eab7ae7961159fd5d4a678eb2166bfc-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/925-3ef497b40eab7ae7961159fd5d4a678eb2166bfc-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/925-3ef497b40eab7ae7961159fd5d4a678eb2166bfc-thumb3.png',
    },
    color: '#639ac6',
    level: 0,
  },
  {
    id: 139,
    url: 'https://www.catawiki.com/en/c/139-books-comics',
    name: 'Books & Comics',
    formatted_name: 'Books & Comics',
    auction_count: 54,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/139-cb500916ac109f4c08f3393df05db15834506bf4-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/139-cb500916ac109f4c08f3393df05db15834506bf4-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/139-cb500916ac109f4c08f3393df05db15834506bf4-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/139-cb500916ac109f4c08f3393df05db15834506bf4-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/139-cb500916ac109f4c08f3393df05db15834506bf4-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/139-cb500916ac109f4c08f3393df05db15834506bf4-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/139-cb500916ac109f4c08f3393df05db15834506bf4-thumb3.png',
    },
    color: '#b0eadf',
    level: 0,
  },
  {
    id: 725,
    url: 'https://www.catawiki.com/en/c/725-cameras-computers',
    name: 'Cameras & Computers',
    formatted_name: 'Cameras & Computers',
    auction_count: 21,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/725-1dd9f38b90ebe457df146fb9365b34b2f6f236a5-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/725-1dd9f38b90ebe457df146fb9365b34b2f6f236a5-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/725-1dd9f38b90ebe457df146fb9365b34b2f6f236a5-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/725-1dd9f38b90ebe457df146fb9365b34b2f6f236a5-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/725-1dd9f38b90ebe457df146fb9365b34b2f6f236a5-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/725-1dd9f38b90ebe457df146fb9365b34b2f6f236a5-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/725-1dd9f38b90ebe457df146fb9365b34b2f6f236a5-thumb3.png',
    },
    color: '#fbb763',
    level: 0,
  },
  {
    id: 708,
    url: 'https://www.catawiki.com/en/c/708-classic-cars-motorcycles-automobilia',
    name: 'Classic Cars, Motorcycles & Automobilia',
    formatted_name: 'Classic Cars, Motorcycles & Automobilia',
    auction_count: 49,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/708-5b13f6a2be7d063b4e8fe2da783c1932f6fabfbb-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/708-5b13f6a2be7d063b4e8fe2da783c1932f6fabfbb-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/708-5b13f6a2be7d063b4e8fe2da783c1932f6fabfbb-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/708-5b13f6a2be7d063b4e8fe2da783c1932f6fabfbb-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/708-5b13f6a2be7d063b4e8fe2da783c1932f6fabfbb-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/708-5b13f6a2be7d063b4e8fe2da783c1932f6fabfbb-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/708-5b13f6a2be7d063b4e8fe2da783c1932f6fabfbb-thumb3.png',
    },
    color: '#a2938f',
    level: 0,
  },
  {
    id: 165,
    url: 'https://www.catawiki.com/en/c/165-coins-stamps',
    name: 'Coins & Stamps',
    formatted_name: 'Coins & Stamps',
    auction_count: 90,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/165-6a45b48471c3d7b4e7a961200c8c3d6f4cbe5472-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/165-6a45b48471c3d7b4e7a961200c8c3d6f4cbe5472-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/165-6a45b48471c3d7b4e7a961200c8c3d6f4cbe5472-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/165-6a45b48471c3d7b4e7a961200c8c3d6f4cbe5472-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/165-6a45b48471c3d7b4e7a961200c8c3d6f4cbe5472-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/165-6a45b48471c3d7b4e7a961200c8c3d6f4cbe5472-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/165-6a45b48471c3d7b4e7a961200c8c3d6f4cbe5472-thumb3.png',
    },
    color: '#d5d3e1',
    level: 0,
  },
  {
    id: 714,
    url: 'https://www.catawiki.com/en/c/714-diamonds-gemstones',
    name: 'Diamonds & Gemstones',
    formatted_name: 'Diamonds & Gemstones',
    auction_count: 91,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/714-a5109f114c18c219b14f1239f48b2be3e9a43e71-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/714-a5109f114c18c219b14f1239f48b2be3e9a43e71-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/714-a5109f114c18c219b14f1239f48b2be3e9a43e71-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/714-a5109f114c18c219b14f1239f48b2be3e9a43e71-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/714-a5109f114c18c219b14f1239f48b2be3e9a43e71-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/714-a5109f114c18c219b14f1239f48b2be3e9a43e71-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/714-a5109f114c18c219b14f1239f48b2be3e9a43e71-thumb3.png',
    },
    color: '#aabac7',
    level: 0,
  },
  {
    id: 721,
    url: 'https://www.catawiki.com/en/c/721-fashion',
    name: 'Fashion',
    formatted_name: 'Fashion',
    auction_count: 54,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/721-8096cc15af3027a9ffc0103dbd02e92880521758-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/721-8096cc15af3027a9ffc0103dbd02e92880521758-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/721-8096cc15af3027a9ffc0103dbd02e92880521758-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/721-8096cc15af3027a9ffc0103dbd02e92880521758-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/721-8096cc15af3027a9ffc0103dbd02e92880521758-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/721-8096cc15af3027a9ffc0103dbd02e92880521758-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/721-8096cc15af3027a9ffc0103dbd02e92880521758-thumb3.png',
    },
    color: '#f3cddb',
    level: 0,
  },
  {
    id: 1,
    url: 'https://www.catawiki.com/en/c/1-interiors-decorations',
    name: 'Interiors & Decorations',
    formatted_name: 'Interiors & Decorations',
    auction_count: 254,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/1-c2efd7018644aa75e18b3cb324460a00c5190ec8-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/1-c2efd7018644aa75e18b3cb324460a00c5190ec8-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/1-c2efd7018644aa75e18b3cb324460a00c5190ec8-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/1-c2efd7018644aa75e18b3cb324460a00c5190ec8-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/1-c2efd7018644aa75e18b3cb324460a00c5190ec8-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/1-c2efd7018644aa75e18b3cb324460a00c5190ec8-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/1-c2efd7018644aa75e18b3cb324460a00c5190ec8-thumb3.png',
    },
    color: '#ccecff',
    level: 0,
  },
  {
    id: 299,
    url: 'https://www.catawiki.com/en/c/299-jewellery-watches',
    name: 'Jewellery & Watches',
    formatted_name: 'Jewellery & Watches',
    auction_count: 230,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/299-fb7718a03573d52adbd4e5eebfcd6654cf43416b-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/299-fb7718a03573d52adbd4e5eebfcd6654cf43416b-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/299-fb7718a03573d52adbd4e5eebfcd6654cf43416b-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/299-fb7718a03573d52adbd4e5eebfcd6654cf43416b-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/299-fb7718a03573d52adbd4e5eebfcd6654cf43416b-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/299-fb7718a03573d52adbd4e5eebfcd6654cf43416b-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/299-fb7718a03573d52adbd4e5eebfcd6654cf43416b-thumb3.png',
    },
    color: '#86a7a8',
    level: 0,
  },
  {
    id: 1099,
    url: 'https://www.catawiki.com/en/c/1099-militaria-weaponry',
    name: 'Militaria & Weaponry',
    formatted_name: 'Militaria & Weaponry',
    auction_count: 13,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/1099-c91383af824868810953f4a385a370ac1bd6deb3-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/1099-c91383af824868810953f4a385a370ac1bd6deb3-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/1099-c91383af824868810953f4a385a370ac1bd6deb3-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/1099-c91383af824868810953f4a385a370ac1bd6deb3-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/1099-c91383af824868810953f4a385a370ac1bd6deb3-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/1099-c91383af824868810953f4a385a370ac1bd6deb3-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/1099-c91383af824868810953f4a385a370ac1bd6deb3-thumb3.png',
    },
    color: '#959464',
    level: 0,
  },
  {
    id: 347,
    url: 'https://www.catawiki.com/en/c/347-music',
    name: 'Music',
    formatted_name: 'Music',
    auction_count: 24,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/347-bf20c26ff35f10b8fe8e93dbb7260206213671e1-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/347-bf20c26ff35f10b8fe8e93dbb7260206213671e1-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/347-bf20c26ff35f10b8fe8e93dbb7260206213671e1-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/347-bf20c26ff35f10b8fe8e93dbb7260206213671e1-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/347-bf20c26ff35f10b8fe8e93dbb7260206213671e1-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/347-bf20c26ff35f10b8fe8e93dbb7260206213671e1-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/347-bf20c26ff35f10b8fe8e93dbb7260206213671e1-thumb3.png',
    },
    color: '#df6957',
    level: 0,
  },
  {
    id: 1097,
    url: 'https://www.catawiki.com/en/c/1097-sports-events',
    name: 'Sports & Events',
    formatted_name: 'Sports & Events',
    auction_count: 19,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/1097-4e013a19c10950c676a890270f37cfe1304cdf1f-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/1097-4e013a19c10950c676a890270f37cfe1304cdf1f-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/1097-4e013a19c10950c676a890270f37cfe1304cdf1f-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/1097-4e013a19c10950c676a890270f37cfe1304cdf1f-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/1097-4e013a19c10950c676a890270f37cfe1304cdf1f-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/1097-4e013a19c10950c676a890270f37cfe1304cdf1f-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/1097-4e013a19c10950c676a890270f37cfe1304cdf1f-thumb3.png',
    },
    color: '#f8de7a',
    level: 0,
  },
  {
    id: 363,
    url: 'https://www.catawiki.com/en/c/363-toys-models',
    name: 'Toys & Models',
    formatted_name: 'Toys & Models',
    auction_count: 58,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/363-810fe30d425ce382bd792358ee1e6b002759f332-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/363-810fe30d425ce382bd792358ee1e6b002759f332-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/363-810fe30d425ce382bd792358ee1e6b002759f332-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/363-810fe30d425ce382bd792358ee1e6b002759f332-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/363-810fe30d425ce382bd792358ee1e6b002759f332-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/363-810fe30d425ce382bd792358ee1e6b002759f332-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/363-810fe30d425ce382bd792358ee1e6b002759f332-thumb3.png',
    },
    color: '#ffb39f',
    level: 0,
  },
  {
    id: 720,
    url: 'https://www.catawiki.com/en/c/720-wine-whisky',
    name: 'Wine & Whisky',
    formatted_name: 'Wine & Whisky',
    auction_count: 91,
    imageUrl:
      'https://assets.catawiki.nl/assets/categories/720-b259e51185df6466fecca2d5556c9fc8f00d3c9f-original.jpg',
    images: {
      banner1:
        'https://assets.catawiki.nl/assets/categories/720-b259e51185df6466fecca2d5556c9fc8f00d3c9f-banner1.png',
      banner2:
        'https://assets.catawiki.nl/assets/categories/720-b259e51185df6466fecca2d5556c9fc8f00d3c9f-banner2.png',
      banner3:
        'https://assets.catawiki.nl/assets/categories/720-b259e51185df6466fecca2d5556c9fc8f00d3c9f-banner3.png',
      thumb1:
        'https://assets.catawiki.nl/assets/categories/720-b259e51185df6466fecca2d5556c9fc8f00d3c9f-thumb1.png',
      thumb2:
        'https://assets.catawiki.nl/assets/categories/720-b259e51185df6466fecca2d5556c9fc8f00d3c9f-thumb2.png',
      thumb3:
        'https://assets.catawiki.nl/assets/categories/720-b259e51185df6466fecca2d5556c9fc8f00d3c9f-thumb3.png',
    },
    color: '#af6663',
    level: 0,
  },
];

export const CATEGORY_STUB = {
  id: -1,
  url: '',
  name: '',
  formatted_name: '',
  imageUrl: '',
  color: '',
  level: 0,
};
